module.exports = __webpack_public_path__ + "static/media/ourstories-screen-guy-girl-care-packages.6b1d158f.png";